module.exports = __webpack_public_path__ + "img/ShipStation.a52f26c8.svg";